<template>
  <section>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
};
</script>

<style lang="scss" scoped>
</style>
